'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = require('../../../../../events');

var _events2 = _interopRequireDefault(_events);

var _print = require('../../../../../print');

var _print2 = _interopRequireDefault(_print);

var _compCards = require('../../../../../print/comp-cards');

var _compCards2 = _interopRequireDefault(_compCards);

var _parentCards = require('../../../../../print/parent-cards');

var _parentCards2 = _interopRequireDefault(_parentCards);

var _ifeisIsomorphic = require('ifeis-isomorphic');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PreFeisPrintoutsController = function () {
  function PreFeisPrintoutsController(feis, fStages, $q, $state, fPrint, fEventService, fFeisService, msgService, fPrintCompCards, fPrintParentCards, stageActions, $mdDialog, $window) {
    var _this = this;

    _classCallCheck(this, PreFeisPrintoutsController);

    this._ = {
      fStages: fStages,
      $q: $q,
      $state: $state,
      fPrint: fPrint,
      fFeisService: fFeisService,
      msgService: msgService,
      fPrintCompCards: fPrintCompCards,
      fPrintParentCards: fPrintParentCards,
      $mdDialog: $mdDialog
    };
    this._stages = fStages.for(feis.id);
    this._events = fEventService.for(feis.id);
    this.feis = feis;
    this.feis.$$days = stageActions.prepareFeisDays(this.feis, this.feis.tz);
    this.isLoading = false;

    this.printouts = [{
      title: 'Competitor Cards: Assigns numbers and generates a PDF of competitor cards with sequence numbers',
      fn: function fn() {
        return _this.generateCompetitorCards();
      }
    }, {
      title: 'Parent Cards: Competitor card dance info and instructions for using iFeis',
      fn: function fn() {
        return _this.generateParentCards();
      }
    }, {
      title: 'Stage Headers: Now/Next signs, recommend printing on 3 hole paper',
      fn: function fn() {
        return _this.generateStageHeaders();
      }
    }, {
      title: 'Scoresheets: Judges sheets in stage schedule order with competition info at top of page',
      fn: function fn() {
        return _this.generateScoresheets();
      }
    }, {
      title: 'Awards Placeholders: Competition info if placing sheets are being posted',
      fn: function fn() {
        return _this.generateAwardPlaceholders();
      }
    }, {
      title: 'Awards Forecast Report',
      href: $state.href('feiseanna.one.admin.reports.awards-forecaster')
    }, {
      title: 'Grades Scoresheet: Blank scoresheet with single round',
      fn: function fn() {
        return $window.open('https://s3.amazonaws.com/cdn.ifeis.net/assets/blank-adjudication-sheet-grades.pdf', '_blank');
      }
    }, {
      title: 'Champs Scoresheet: Blank scoresheet with 3 rounds',
      fn: function fn() {
        return $window.open('https://s3.amazonaws.com/cdn.ifeis.net/assets/blank-adjudication-sheet-champs.pdf', '_blank');
      }
    }, {
      title: 'Competitor Stats By Schools: List of schools and the paid/unpaid dancer counts',
      href: $state.href('feiseanna.one.admin.schools')
    }];
  }

  _createClass(PreFeisPrintoutsController, [{
    key: '_withCompetitorNumbers',
    value: function _withCompetitorNumbers() {
      var _this2 = this;

      if (this.feis.has_competitor_numbers_assigned) {
        return this._.$q.resolve();
      }

      var confirm = this._.$mdDialog.confirm().title('Assign competitor numbers?').textContent('This process will assign competitor numbers to all registered competitors.').cancel('Cancel').ok('Assign');

      return this._.$mdDialog.show(confirm).then(function () {
        return _this2._.fFeisService.assignCompetitorNumbers(_this2.feis.id);
      }).then(function (feis) {
        return _this2.feis = feis;
      }).catch(function (err) {
        if (err.status === 404) {
          var warning = _this2._.$mdDialog.alert().title('This Feis Has No Competitors').textContent("It looks like your feis doesn't have any registered competitors. Until you have competitors, you can't assign competitor numbers.").ok('Close');
          _this2._.$mdDialog.show(warning);
        } else {
          err && _this2._.msgService.displayErrorMsg(err);
        }
      });
    }
  }, {
    key: 'generateStageHeaders',
    value: function generateStageHeaders() {
      var _this3 = this;

      this.isLoading = true;

      var stages = void 0;
      var events = void 0;

      return this._.fPrint.getLogo().then(function (logo) {
        return _this3.logo = logo;
      }).then(function () {
        return _this3._.$q.all([_this3._stages.all(), _this3._events.all()]);
      }).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            s = _ref2[0],
            e = _ref2[1];

        stages = s.map(function (s) {
          return _this3._stages.withStage(s.id, s);
        });
        events = e.reduce(function (o, e) {
          o[e.id] = e;return o;
        }, {});

        return _this3._.$q.all(stages.map(function (s) {
          return s.schedule(true);
        }));
      }, function (err) {
        return _this3._.msgService.displayErrorMsg(err);
      }).then(function (s) {
        stages.forEach(function (stage, idx) {
          stage.$schedule = s[idx].filter(function (e) {
            return !e.placeholder;
          });
        });

        // Sort stages by date and name
        return stages.sort(function (a, b) {
          return a._stage.dt !== b._stage.dt ? a._stage.dt > b._stage.dt : a._stage.name > b._stage.name;
        });
      }).then(function (stages) {
        var headlineSize = 150;
        var compNumberSize = 200;
        var subheadSize = 14;
        var normalFont = 'Helvetica';
        var bold = 'Helvetica-Bold';

        var _$fPrint$metrics = _this3._.fPrint.metrics(true),
            margin = _$fPrint$metrics.margin,
            pageWidth = _$fPrint$metrics.pageWidth,
            useablePageWidth = _$fPrint$metrics.useablePageWidth,
            pageHeight = _$fPrint$metrics.pageHeight;

        var doc = _this3._.fPrint.create('stage-headers.pdf', { layout: 'landscape' });

        stages.forEach(function (stage, idx) {
          if (idx > 0) doc.addPage();

          var stageDay = _this3.feis.$$days.find(function (d) {
            return d.date === stage._stage.dt;
          });
          var feisName = _this3.feis.name;

          doc.fontSize(headlineSize / 10);
          doc.text(feisName ? '' + feisName : '', {
            align: 'center'
          });

          doc.image(_this3.logo, 10, 10, { width: 60 });
          doc.y = 225;
          doc.fontSize(headlineSize);
          doc.text(stage.name(), {
            align: 'center',
            lineBreak: true
          });
          doc.fontSize(headlineSize / 2);
          doc.text(stageDay ? '' + stageDay.title : '', {
            align: 'center'
          });

          stage.$schedule.forEach(function (e, num) {
            var event = events[e.id];

            doc.addPage();

            doc.fontSize(headlineSize / 10);
            doc.text(feisName ? '' + feisName : '', {
              align: 'center'
            });

            var fontWidthToHeightRatio = 0.7; // approximation

            // adjust font size to fit event name on one line
            compNumberSize = useablePageWidth / event.name.length / fontWidthToHeightRatio;

            var MAX_COMP_NUMBER_FONT_SIZE = 200;
            compNumberSize = Math.min(MAX_COMP_NUMBER_FONT_SIZE, compNumberSize);

            doc.y = 225;
            doc.fontSize(compNumberSize).font(bold);
            doc.text(event.name, {
              align: 'center'
            });

            doc.image(_this3.logo, 10, 10, { width: 60 });

            doc.fontSize(subheadSize).font(normalFont);
            doc.y = 525;
            doc.text((0, _ifeisIsomorphic.getDescription)(event), {
              align: 'center'
            });
            doc.text(stageDay ? stageDay.title + ': Event #' + (num + 1) + ' on ' + stage.name() : 'Event #' + (num + 1) + ' on ' + stage.name(), {
              align: 'center'
            });
          });
        });

        return _this3._.fPrint.download(doc);
      }).then(function () {
        _this3.isLoading = false;
      }).catch(function (e) {
        return _this3._.msgService.displayErrorMsg(e.stack);
      });
    }
  }, {
    key: 'generateAwardPlaceholders',
    value: function generateAwardPlaceholders() {
      var _this4 = this;

      this.isLoading = true;

      return this._.fPrint.getLogo().then(function (logo) {
        return _this4.logo = logo;
      }).then(function () {
        return _this4._events.all();
      }).then(function (events) {
        var doc = _this4._.fPrint.create('awards-placeholders.pdf');
        var headlineSize = 84;
        var subheadSize = 34;
        var feisName = _this4.feis.name;

        events.forEach(function (event, idx) {
          if (idx > 0) {
            doc.addPage();
          }

          /* Showing feisName */
          doc.fontSize(headlineSize / 7);
          doc.text(feisName ? '' + feisName : '', {
            align: 'center'
          });

          doc.y = 275;
          doc.fontSize(headlineSize);
          doc.text(event.name, {
            align: 'center',
            lineBreak: true
          });

          doc.fontSize(subheadSize);
          doc.text((0, _ifeisIsomorphic.getDescription)(event), {
            align: 'center',
            lineBreak: true
          });

          doc.image(_this4.logo, 10, 10, { width: 60 });

          doc.moveDown();
          doc.moveDown();
          doc.text('No Results Yet', {
            align: 'center',
            lineBreak: true
          });
        });

        _this4.isLoading = false;
        return _this4._.fPrint.download(doc);
      }).catch(function (e) {
        return _this4._.msgService.displayErrorMsg(e.stack);
      });
    }
  }, {
    key: 'generateCompetitorCards',
    value: function generateCompetitorCards() {
      var _this5 = this;

      this.isLoading = true;

      return this._withCompetitorNumbers().then(function () {
        return _this5._.fPrint.getLogo();
      }).then(function (logo) {
        return _this5.logo = logo;
      })
      // print the competitor cards
      .then(function () {
        return _this5._.fPrintCompCards(_this5.feis.id);
      }).catch(function (err) {
        return err && _this5._.msgService.displayErrorMsg(err);
      }).finally(function () {
        return _this5.isLoading = false;
      });
    }
  }, {
    key: 'generateParentCards',
    value: function generateParentCards() {
      var _this6 = this;

      this.isLoading = true;

      return this._withCompetitorNumbers()
      // print the parent cards
      .then(function () {
        return _this6._.fPrintParentCards(_this6.feis.id);
      })

      // catch any errors and reset loading state
      .catch(function (err) {
        return err && _this6._.msgService.displayErrorMsg(err);
      }).finally(function () {
        return _this6.isLoading = false;
      });
    }
  }, {
    key: 'generateScoresheets',
    value: function generateScoresheets() {
      var _this7 = this;

      this.isLoading = true;

      var stages = void 0;
      var events = void 0;
      var feisName = this.feis.name;

      return this._.fPrint.getLogo().then(function (logo) {
        return _this7.logo = logo;
      }).then(function () {
        return _this7._.$q.all([_this7._stages.all(), _this7._events.all()]);
      }).then(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            s = _ref4[0],
            e = _ref4[1];

        stages = s.map(function (s) {
          return _this7._stages.withStage(s.id, s);
        });
        events = e.reduce(function (o, e) {
          o[e.id] = e;return o;
        }, {});

        return _this7._.$q.all(stages.map(function (s) {
          return s.schedule(true);
        }));
      }, function (err) {
        return _this7._.msgService.displayErrorMsg(err);
      }).then(function (s) {
        stages.forEach(function (stage, idx) {
          stage.$schedule = s[idx].filter(function (e) {
            return !e.placeholder;
          });
        });

        // Sort stages by date and name
        return stages.sort(function (a, b) {
          return a._stage.dt !== b._stage.dt ? a._stage.dt > b._stage.dt : a._stage.name > b._stage.name;
        });
      }).then(function (stages) {
        var titleSize = 50;
        var headlineSize = 24;
        var subheadSize = 14;

        var _$fPrint$metrics2 = _this7._.fPrint.metrics(),
            margin = _$fPrint$metrics2.margin,
            pageWidth = _$fPrint$metrics2.pageWidth,
            useablePageWidth = _$fPrint$metrics2.useablePageWidth,
            pageHeight = _$fPrint$metrics2.pageHeight;

        var positionY = void 0;

        var doc = _this7._.fPrint.create('scoresheets.pdf');

        stages.forEach(function (stage, idx) {
          if (idx > 0) doc.addPage();

          var stageDay = _this7.feis.$$days.find(function (d) {
            return d.date === stage._stage.dt;
          });

          doc.image(_this7.logo, 10, 10, { width: 60 });

          // doc.fontSize( titleSize );
          // doc.text( stageDay ? `${stageDay.title}: ${stage.name()}` : `${stage.name()}`, {
          //   align: 'center'
          // });

          doc.y = 225;
          doc.fontSize(titleSize);
          doc.text(stageDay ? stageDay.title + ': ' + stage.name() : '' + stage.name(), {
            align: 'center',
            lineBreak: true
          });

          /* Showing feisName */
          doc.fontSize(12);
          doc.text(feisName ? '' + feisName : '', 250, 20);

          stage.$schedule.forEach(function (e, num) {
            var event = events[e.id];

            var num_rounds = event.rounds ? event.rounds : event.type === 'C' ? 3 : 1;
            var num_adjudicators = event.type === 'C' ? 3 : 1;

            // When event has more than 10 participants, add more pages to fit all of them
            var pages = Math.floor(e.participants / 10) + 1;
            // Prepare page copies for all adjudicators
            var pageCopies = pages * num_adjudicators;

            var addPage = function addPage() {
              doc.addPage();

              /* Showing feisName */
              doc.fontSize(12);
              doc.text(feisName ? '' + feisName : '', 250, 10);

              positionY = margin;

              /* Showing ifeis logo */
              doc.image(_this7.logo, 10, 10, { width: 60 });

              doc.fontSize(headlineSize);
              doc.text((0, _ifeisIsomorphic.getDescription)(event), margin, positionY, {
                align: 'center',
                lineBreak: true,
                width: useablePageWidth,
                height: headlineSize,
                ellipsis: true
              });
              positionY += headlineSize;

              positionY += 10;
              doc.fontSize(11);
              doc.text(stageDay ? stageDay.title + ': Event #' + (num + 1) + ' on ' + stage.name() : 'Event #' + (num + 1) + ' on ' + stage.name(), margin, positionY, {
                align: 'left',
                lineBreak: true,
                width: useablePageWidth,
                height: 10,
                continued: true,
                ellipsis: true
              });
              positionY += 18;

              // Adjudicator name
              doc.fontSize(11);
              doc.text('Adjudicator name: _____________________________', {
                align: 'right',
                width: useablePageWidth,
                lineBreak: true
              });

              var width = useablePageWidth;
              var height = 62;
              var numRows = 11;
              var tableStartY = positionY;
              var tableEndY = tableStartY + ((numRows - 1) * height + 32);
              var positionX = margin;
              var cols = [{
                label: 'Comp #',
                w: width * 0.1,
                fontSize: 11
              }];

              if (num_rounds === 1) {
                cols.push({
                  label: 'Score',
                  w: width * 0.2
                });
              } else {
                var numFields = num_rounds + 1;
                if (num_rounds > 2) {
                  numFields += 1;
                }
                for (var r = 1; r <= num_rounds; r++) {
                  if (r === 3) {
                    cols.push({
                      label: 'Sub',
                      w: width * (0.4 / numFields)
                    });
                  }

                  cols.push({
                    label: 'R' + r,
                    w: width * (0.4 / numFields)
                  });
                }

                cols.push({
                  label: 'Total',
                  w: width * (0.4 / numFields)
                });
              }

              cols = cols.concat([{
                label: 'Comments',
                w: num_rounds === 1 ? width * 0.63 : width * 0.43
              }, {
                label: 'Dress',
                w: width * 0.07,
                align: 'left',
                fontSize: 10
              }]);

              // Calculate column starting positions
              cols.forEach(function (col) {
                col.x = positionX;
                positionX += col.w;
              });

              // Add end column line
              cols.push({ x: pageWidth - margin });

              // Draw row lines
              for (var _r = 0; _r <= numRows; _r++) {
                doc.moveTo(margin, positionY).lineTo(margin + width, positionY).stroke();

                /* Showing two line after last row of table */
                if (numRows === _r) {
                  doc.fontSize(8);
                  doc.text('_________________________          _________________________', margin, positionY + 8, {
                    align: 'center'
                  });
                }

                positionY += _r === 0 ? 32 : height;
              }

              // Draw column lines
              cols.forEach(function (col) {
                doc.moveTo(col.x, tableStartY).lineTo(col.x, tableEndY).stroke();

                if (!col.label) return;
                doc.fontSize(col.fontSize ? col.fontSize : subheadSize);
                doc.text(col.label, col.x, tableStartY + (32 - subheadSize) / 2, {
                  height: height,
                  width: col.w,
                  align: 'center',
                  lineBreak: false,
                  ellipsis: true
                });
              });
            };

            for (var a = 0; a < pageCopies; a++) {
              addPage();
            }
          });
        });

        return _this7._.fPrint.download(doc);
      }).then(function () {
        _this7.isLoading = false;
      }).catch(function (e) {
        return _this7._.msgService.displayErrorMsg(e.stack);
      });
    }
  }]);

  return PreFeisPrintoutsController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.pre-feis-printouts', ['ifeis.events', 'ifeis.printing', 'ifeis.routes.feiseanna.one.admin.reports.stage-headers', 'ifeis.routes.feiseanna.one.admin.schools', 'ifeis.routes.feiseanna.one.admin.reports.awards-forecaster', 'ifeis.router-history', 'ifeis.printing.compcards', 'ifeis.printing.parentcards']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.pre-feis-printouts', {
    url: '/printouts',
    template: require('./tpl.html'),
    controller: PreFeisPrintoutsController,
    controllerAs: 'pfp',
    ncyBreadcrumb: {
      label: 'Pre-Feis Printouts',
      parent: 'feiseanna.one.admin.manager'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/pre-feis-printouts/index.js
// module id = 550
// module chunks = 0